import { Link } from "react-router-dom";
import { pushEvent } from "@/utils/dataLayer";

const MethodologySection = () => (
  <section className="methodology-results">
    <div className="container">
      <span className="section-label">01 — METHODOLOGY</span>
      <h2 className="section-main-title">THE<br />ARCHITECTURE.</h2>

      {/* Card 1: Black */}
      <div className="transformation-card transformation-black">
        <span className="transformation-number">01</span>
        <div className="transformation-content">
          <h3 className="transformation-title">TRANSFORMATION<br />OF THOUGHT</h3>
          <span className="method-desc-mono">From Aesthetic Brochure to Operational Tool.</span>
          <p className="transformation-body">
            Before we talk about platforms or features, we figure out one thing: <strong>Where is the actual bottleneck?</strong>
          </p>
          <p className="transformation-body">
            Is it clarity?<br />Is it efficiency?<br />Is it filtering the right leads?<br />Is it stability?<br />We don't guess. We diagnose.
          </p>
        </div>
      </div>

      {/* Card 2: Red */}
      <div className="transformation-card transformation-red">
        <span className="transformation-number">02</span>
        <div className="transformation-content">
          <h3 className="transformation-title">TRANSFORMATION<br />OF SYSTEM</h3>
          <span className="method-desc-mono">From Liability to Problem-Solving Asset.</span>
          <p className="transformation-body">
            Once we identify the constraint, we build around that. Not around trends. Not around templates.
          </p>
          <p className="transformation-body">
            Sometimes that means rebuilding the structure. Sometimes it means adding a tool. Sometimes it means simplifying what's already there.
          </p>
          <p className="transformation-body">
            <strong>The format is flexible. The goal is operational clarity.</strong>
          </p>
        </div>
      </div>

      {/* Card 3: Grey */}
      <div className="transformation-card transformation-grey">
        <span className="transformation-number">03</span>
        <div className="transformation-content">
          <h3 className="transformation-title">TRANSFORMATION<br />OF PROCESS</h3>
          <span className="method-desc-mono">From Fragile to Future-Proof.</span>
          <p className="transformation-body">
            Some owners want to update content themselves. Some want to manage everything. Some want to touch nothing.
          </p>
          <p className="transformation-body">
            <strong>We decide that together.</strong>
          </p>
          <p className="transformation-body">
            Every system has two parts: <strong>The Engine</strong> — Stable, structured, built properly. <strong>The Controls</strong> — The parts you choose to manage.
          </p>
          <p className="transformation-body">
            If you're comfortable editing text, I build a clean interface. If you never want to log in, you won't have to. If you want ownership of everything, you'll have it.
          </p>
          <p className="transformation-body">
            <strong>You should only control what you're comfortable controlling. No more. No less.</strong>
          </p>
        </div>
      </div>

      {/* CTAs */}
      <div className="methodology-ctas">
        <Link to="/protocol" className="transformation-cta" onClick={() => pushEvent('cta_click', { label: 'READ ABOUT MY APPROACH', location: 'methodology' })}>
          READ ABOUT MY APPROACH
        </Link>
        <Link to="/infrastructure" className="transformation-cta" onClick={() => pushEvent('cta_click', { label: 'VIEW CAPABILITIES', location: 'methodology' })}>
          VIEW CAPABILITIES
        </Link>
      </div>
    </div>
  </section>
);

export default MethodologySection;
